import React from 'react';

/**
 * The progress of anything that pulls, loads or saves data (owner, 3 Oct 2026: "اعمل مؤشر فى اى حاجه بتسحب او بتحمل او
 * تخزن بيانات من 1 ل 100 علشان المستخدم يكون عارف فاضل قد ايه ويخلص كنسبة مؤية"): the bar, the percent, "x of y" and
 * where it stands - running, finished or stopped (and why).
 *   <ProgressBar done={150} total={1485} unit="contracts" state="running" label="Reading Ejar" />
 */
const TONE = {
    running: { bar: 'bg-purple-600', text: 'text-purple-800', word: 'Running' },
    done: { bar: 'bg-green-600', text: 'text-green-800', word: 'Finished' },
    stopped: { bar: 'bg-red-600', text: 'text-red-700', word: 'Stopped' },
};

export const percentOf = (done, total) => (total > 0 ? Math.min(100, Math.floor((Number(done) || 0) / total * 100)) : 0);

export default function ProgressBar({ done = 0, total = 0, unit = 'items', state = 'running', label = '', note = '' }) {
    const tone = TONE[state] || TONE.running;
    // finished = 100 % whatever the count says; before the total is known the bar waits (no value: indeterminate)
    const pct = state === 'done' ? 100 : percentOf(Math.max(0, Number(done) || 0), total);
    const counting = !total && state === 'running';
    const count = total
        ? `${Math.max(0, Number(done) || 0).toLocaleString('en-US')} of ${Number(total).toLocaleString('en-US')} ${unit}`
        : counting ? `counting the ${unit}…` : `no ${unit} to read`;
    return (
        <div className="flex flex-col gap-1">
            <div className="flex flex-wrap items-baseline justify-between gap-2 text-sm" aria-live="polite">
                <span className={`font-semibold ${tone.text}`}>
                    {tone.word}{label ? ` · ${label}` : ''}
                    {state === 'running' && <span className="ml-1 animate-pulse motion-reduce:animate-none">…</span>}
                </span>
                <span className="tabular-nums text-gray-800">
                    <b className={`text-base ${tone.text}`}>{pct}%</b>
                    <span className="ml-2">{count}</span>
                </span>
            </div>
            <div className="h-2.5 rounded-full bg-gray-200 overflow-hidden" role="progressbar" aria-label="Progress"
                aria-valuemin={0} aria-valuemax={100} aria-valuenow={counting ? undefined : pct}
                aria-valuetext={counting ? `counting the ${unit}` : `${pct}% - ${count}`}>
                <div className={`h-full ${tone.bar} transition-all duration-500 motion-reduce:transition-none`} style={{ width: `${pct}%` }} />
            </div>
            {note && (
                <div role={state === 'stopped' ? 'alert' : undefined}
                    className={`text-xs ${state === 'stopped' ? 'text-red-700 font-medium' : 'text-gray-600'}`}>{note}</div>
            )}
        </div>
    );
}
